// src/components/layout/AppLayout.jsx
import React, { useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar"; 
import CreateAgentModal from "../agent/CreateAgentModal"; // Impor modal

const AppLayout = () => {

  const [isCreateAgentModalOpen, setIsCreateAgentModalOpen] = useState(false);
  const location = useLocation(); 

  const openCreateAgentModal = () => setIsCreateAgentModalOpen(true);
  const closeCreateAgentModal = () => setIsCreateAgentModalOpen(false);

  const handleAgentCreatedInModal = useCallback(() => {
    closeCreateAgentModal();
    console.log(
      "Agent created via modal, MyAgentsPage should refetch if it's the current view or next view."
    );
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-black text-slate-200">
      <Navbar />
      <div className="flex-1 pt-16 container mx-auto px-4 py-8">
        <Outlet />
      </div>
      <CreateAgentModal
        isOpen={isCreateAgentModalOpen}
        onClose={closeCreateAgentModal}
        onAgentCreated={handleAgentCreatedInModal}
      />
    </div>
  );
};

export default AppLayout;
